<template>
    <el-form size="mini" :inline="true" :model="form">
        <el-form-item label="转诊时间">
            <el-date-picker
                v-model="form.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期" style="width: 180px">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="">
            <el-date-picker
                v-model="form.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期" style="width: 180px">
            </el-date-picker>
        </el-form-item>
        <!--<el-form-item>-->
            <!--<el-select v-model="form.referralType" placeholder="转诊类型" disabled>-->
                <!--<el-option v-for="(data,index) in REFERRAL_TYPE" :key="index" :label="data.name"-->
                           <!--:value="data.name"></el-option>-->
            <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="统计类型">
            <el-select v-model="form.aspectUser" placeholder="统计类型">
                <el-option v-for="(data,index) in type" :key="index" :label="data.name"
                           :value="data.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="form.referralStatusList" placeholder="状态">
                <el-option v-for="(data,index) in status" :key="index" :label="data.name"
                           :value="data.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="success" @click="handler('query')">查询</el-button>
            <el-button type="primary" @click="handler('output')">导出报表</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
  import {REFERRAL_STATUS, REFERRAL_TYPE, STATISTICS_TYPE} from "../../lib/config";
  import {referralFormMixin} from "../../lib/mixins/referral-form";
  import {getOneMonTime} from "../../lib/hos/until"

  export default {
    name: "referral-search-form2",
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        REFERRAL_TYPE,
        type: [{name: '全部', id: undefined}, ...STATISTICS_TYPE],
        status: [{name: '全部', id: undefined}, ...REFERRAL_STATUS],
        form: {
            referralType: '',
            aspectUser: undefined,
            referralStatusList: undefined,
            startTime:"",
            endTime:""

        }
      }
    },
    mixins: [referralFormMixin],
    created() {
        let time = getOneMonTime();
        this.form.startTime = time.start;
        this.form.endTime = time.end;
    },
    watch: {
      $route() {
        this.setFormReferralType();
      }
    },
    methods: {
      handler(type) {
        let form = {...this.form};
        const map = {
          query() {
            this.$emit('search', form);
          },
          output() {
            this.$emit('output');
          }
        };
        map[type].call(this);
      }
    },
  }
</script>

<style scoped>

</style>
